export const footer = {
  contact: "Contato",
  phone1: "986 369 778",
  phone2: "676 367 580",
  email: "info@gandaraschool.com",
  address1: "Lugar de Moureira, 1, Mañufe",
  address2: "36388 Gondomar (Pontevedra)",
  schedule: "Horário",
  weekdays: "Segunda a Sexta",
  hours: "8:15 - 17:00",
  follow: "Siga-nos",
  slogan: "Aprendizagem vivencial, trilíngue e ativa",
  theSchool: "A Escola",
  admissions: "Admissões",
  activities: "Atividades",
  viewOnMap: "Ver no Google Maps",
  bookVisitCta: "Reservar visita",
  allRightsReserved: "Todos os direitos reservados",
  links: {
    aboutUs: "Sobre Nós",
    montessori: "Método Montessori",
    trilingual: "Educação Trilíngue",
    services: "Serviços",
    extracurriculars: "Extracurriculares",
    admissionProcess: "Processo de Admissão",
    prices: "Preços e Tarifas",
    visitSchool: "Visite a Escola",
    openHouse: "Dia de Portas Abertas",
    birthdays: "Aniversários",
    easterCamp: "Acampamento Páscoa",
    summerCamp: "Acampamento Verão",
    courses: "Cursos"
  }
};
